import React, { useState, useEffect, useRef } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, ClipboardClock, Trash2, Info, Eye, ClipboardPaste, MoveLeft, SquarePen, PenOff } from "lucide-react";
import Loader from '../../components/Loader.jsx';
import Toggle from '../../components/Toggle.jsx';
import Table from "../../components/Table.jsx";
import PopUp from "../../components/PopUp.jsx";
import Input from "../../components/Input.jsx";
import Combobox from "../../components/Combobox.jsx";
import Alert from "../../components/Alert";
import Button from "../../components/Button.jsx";

let stati = [];

const RowPCAttesa = ({ data }) => {
    return (
        <div className="grid grid-cols-3 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
            <div className="flex items-center pl-2 ">
                {data.value.EmailUtente}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.NomeAzienda}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.DataIntervento}
            </div>
        </div>
    );
};

const RowPCChiusi = ({ data }) => {
    return (
        <div className="grid grid-cols-4 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
            <div className="flex items-center pl-2 ">
                {data.value.EmailUtente}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.NomeAzienda}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.DataIntervento}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.DataChiusura}
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm" style={header.key === "StatoAssunto" ? { color: stati.find((d) => d.Nome === data.value[header.key])?.Colore } : {}}>
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Report = () => {
    const headersAttesa = [
        { label: "Email Utente", key: "EmailUtente" },
        { label: "Nome Cliente", key: "NomeAzienda" },
        { label: "Data/Date Intervento", key: "DataIntervento" }
    ];
    const headersChiusi = [
        { label: "Email Utente", key: "EmailUtente" },
        { label: "Nome Cliente", key: "NomeAzienda" },
        { label: "Data/Date Intervento", key: "DataIntervento" },
        { label: "Data Chiusura", key: "DataChiusura" }
    ];
    const headersManut = [
        { label: 'Data', key: 'Data' },
        { label: 'Descrizione', key: 'Descrizione' },
        { label: 'Email Utente', key: 'EmailUtente' },
        { label: 'Nome Cliente', key: 'NomeAzienda' },
        { label: 'Nome Componente', key: 'NomeComponente' },
        { label: 'Descrizione Componente', key: 'DescrizioneComponente' },
        { label: 'Sito', key: 'Impianto' },
        { label: 'Stato', key: 'StatoAssunto' }
    ];
    const [dataTableAttesa, setDataTableAttesa] = useState([]);
    const [dataTableChiusi, setDataTableChiusi] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [stateToggle, setStateToggle] = useState(false);
    const toggleRef = useRef(null);
    const navigate = useNavigate();
    const [stepAttesa, setStepAttesa] = useState(false);
    const [stepChiusi, setStepChiusi] = useState(false);
    const [isReportAVisible, setIsReportAVisible] = useState(false);
    const [isReportCVisible, setIsReportCVisible] = useState(false);
    const [isManutVisible, setIsManutVisible] = useState(false);
    const [infoReport, setInfoReport] = useState(null);
    const [infoManut, setInfoManut] = useState(null);
    const [needConfirm, setNeedConfirm] = useState(false);
    const [dataManut, setDataManut] = useState(null);
    const [rowSelected, setRowSelected] = useState(null);
    const [contentReport, setContentReport] = useState(null);
    const [isReportVisible, setIsReportVisible] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        //getInfoUtente
        try {

            await loadNav();

            //loadDati
            const r1 = await fetch('/getReport', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTableAttesa(
                    rd1
                        .filter(item => item.DataChiusura === null)
                        .map(item => ({ value: { ...item, "DataIntervento": item.DataFine !== null ? item.DataInizio + " - " + item.DataFine : item.DataInizio } }))
                );
                setDataTableChiusi(
                    rd1
                        .filter(item => item.DataChiusura !== null)
                        .map(item => ({ value: { ...item, "DataIntervento": item.DataFine !== null ? item.DataInizio + " - " + item.DataFine : item.DataInizio } }))
                );
            }

            const r3 = await fetch('/getStati', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd3 = await r3.json();
            if (r3.status === 500) {
                console.log(rd3.error);
                setAlertInfo({ type: "error", text: rd3.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                stati = rd3;
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const loadManutenzioniByReport = async (idReport) => {
        setInfoManut(null);
        setIsLoading(true);
        try {
            const r = await fetch('/getManutenzioniByReport', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CodiceDominio": infoUtente.CodiceDominio,
                    "IDReport": idReport
                })
            });
            const rd = await r.json();
            if (r.status === 500) {
                console.log(rd.error);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setInfoManut(rd.map(item => ({ value: item })));
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const previewReport = async () => {
        setIsLoading(true);
        try {
            const r = await fetch('/getPreviewReport', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "CodiceDominio": infoUtente.CodiceDominio,
                    "IDReport": infoReport.ID
                })
            });
            if (r.status !== 200) {
                const rd = await r.json();
                console.log(rd);
                setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
                setIsReportVisible(false);
            }
            else {
                const rd = await r.json();
                setContentReport(rd.html);
                setIsReportVisible(true);
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della preview, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
            setShowAlert(true);
            setIsReportVisible(false);
        }
        setIsLoading(false);
    };

    const eliminaReport = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CodiceDominio": infoUtente.CodiceDominio,
                        "ID": infoReport.ID
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    window.location.reload();
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare il report selezionato? L'operazione è irreversibile.", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const confirmModificaManut = async () => {
        if (JSON.stringify(dataManut) !== JSON.stringify(rowSelected)) {
            let modifiche = {};
            Object.keys(dataManut.value).forEach(key => {
                if (dataManut.value[key] !== rowSelected.value[key]) {
                    modifiche[key] = dataManut.value[key];
                }
            });

            setIsLoading(true);

            try {
                const r = await fetch('/addModificaReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CodiceDominio": infoUtente.CodiceDominio,
                        "IDReport": infoReport.ID,
                        "IDManutenzione": rowSelected.value.ID,
                        "Modifiche": modifiche,
                        "IsRimozione": false
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setNeedConfirm(false);
                    setIsManutVisible(false);
                    loadManutenzioniByReport(infoReport.ID);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        }
    };

    const rimuoviDaReport = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/addModificaReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CodiceDominio": infoUtente.CodiceDominio,
                        "IDReport": infoReport.ID,
                        "IDManutenzione": rowSelected.value.ID,
                        "Modifiche": {},
                        "IsRimozione": true
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setIsManutVisible(false);
                    loadManutenzioniByReport(infoReport.ID);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler rimuovere la manutenzione selezionata dal report? L'operazione è irreversibile.", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const ripristinaModifiche = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/ripristinaModificheReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CodiceDominio": infoUtente.CodiceDominio,
                        "IDReport": infoReport.ID,
                        "IDManutenzione": rowSelected.value.ID
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setNeedConfirm(false);
                    setIsManutVisible(false);
                    loadManutenzioniByReport(infoReport.ID);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler ripristinare le modifiche effettuate alla manutenzione selezionata? L'operazione è irreversibile.", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    const inviaReport = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/sendReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CodiceDominio": infoUtente.CodiceDominio,
                        "IDReport": infoReport.ID
                    })
                });
                if (r.status === 500) {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); }, needConfirm: false });
                    setShowAlert(true);
                } else {
                    setAlertInfo({ type: "success", text: "Report inviato con successo al cliente.", onClose: () => { setShowAlert(false); window.location.reload(); }, needConfirm: false });
                    setShowAlert(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler inviare il report selezionato al cliente? Una volta inviato non sarà più modificabile.", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"REPORT"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <div className="mx-2 md:w-[30%] md:mx-auto my-3 flex justify-between items-center">
                    <span className="text-lg font-semibold items-center"> Report in attesa <ClipboardClock size={20} strokeWidth={2} className="inline-block ml-0.5" /></span>
                    <Toggle ref={toggleRef} onToggleChange={(value) => setStateToggle(value)} isDouble={true} />
                    <span className="text-lg font-semibold items-center"> Report chiusi <ClipboardCheck size={20} strokeWidth={2} className="inline-block ml-0.5" /></span>
                </div>
                {!stateToggle ? (
                    // Report in attesa
                    <>
                        <Table
                            headers={headersAttesa}
                            keyForPreview={["NomeAzienda", "DataIntervento"]}
                            data={dataTableAttesa}
                            setData={setDataTableAttesa}
                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCAttesa data={rowData} />}
                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                            itemsPC={8}
                            itemsMobile={5}
                            needResearch={true}
                            notFoundMessage="Nessun report in attesa"
                            clickableRow={true}
                            actionRow={(row, rowIndex) => {
                                setInfoReport(row.value); setStepAttesa(false); loadManutenzioniByReport(row.value.ID); setIsReportAVisible(true);
                            }}
                        />
                        <PopUp title={stepAttesa ? "Manutenzioni Eseguite" : ""}
                            isVisible={isReportAVisible}
                            setIsVisible={setIsReportAVisible}
                        >
                            {
                                stepAttesa ? (
                                    <div className="flex flex-col">
                                        <div className="flex items-center justify-between w-full mt-2">
                                            <div className="flex items-center hover:cursor-pointer text-blue-600" onClick={() => { setStepAttesa(false); }}>
                                                <MoveLeft size={16} strokeWidth={2} className="inline-block mr-1" /> TORNA INDIETRO
                                            </div>
                                        </div>
                                        <Table
                                            headers={headersManut}
                                            keyForPreview={['Data', 'EmailUtente', 'NomeComponente', 'Descrizione']}
                                            data={infoManut}
                                            setData={setInfoManut}
                                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCAttesa data={rowData} />}
                                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                            forceSmall={true}
                                            itemsPC={8}
                                            itemsMobile={3}
                                            needResearch={true}
                                            classes="mt-2"
                                            // notFoundMessage="Nessuna manutenzione eseguita"
                                            clickableRow={true}
                                            actionRow={(row, rowIndex) => { setIsManutVisible(true); setNeedConfirm(false); setDataManut(row); setRowSelected(row); }}
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <div className="grid grid-cols-2 mt-2 gap-2">
                                            <Button type="hollow" onClick={eliminaReport}>
                                                ELIMINA <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => { setStepAttesa(true); }}>
                                                INFO MANUTENZIONI <Info size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => { previewReport(); }}>
                                                PREVIEW PDF <Eye size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={inviaReport}>
                                                INVIA AL CLIENTE <ClipboardPaste size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                    </>
                                )}
                        </PopUp>
                        <PopUp title={needConfirm ? "Modifica Manutenzione" : ""}
                            isVisible={isManutVisible}
                            setIsVisible={setIsManutVisible}
                            needConfirm={needConfirm}
                            confirmAction={confirmModificaManut}
                            cancelAction={() => { setNeedConfirm(false); setDataManut(rowSelected); }}
                        >
                            {needConfirm && (
                                <div className="flex flex-col items-center">
                                    <Input
                                        label="Descrizione"
                                        value={dataManut.value["Descrizione"]}
                                        setValue={(value) => setDataManut(prev => ({ ...prev, value: { ...prev.value, Descrizione: value } }))}
                                        type="text"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        disabled={false}
                                        error={false}
                                    />
                                    <Combobox
                                        options={stati.map((d) => ({ label: d.Nome, value: d.ID }))}
                                        onChange={(value) => {
                                            setDataManut(prev => ({
                                                ...prev,
                                                value: {
                                                    ...prev.value,
                                                    StatoAssunto: stati.find((d) => d.ID === value)?.Nome
                                                }
                                            }));
                                        }}
                                        label="Stato Assunto"
                                        classes="w-[80%] md:w-[70%] mt-2"
                                        defaultValue={stati.find((d) => d.Nome === dataManut.value["StatoAssunto"])?.ID || null}
                                    />
                                </div>
                            )}
                            {!needConfirm && (
                                <>
                                    <div className="grid grid-cols-2 gap-2">
                                        <Button type="hollow" onClick={rimuoviDaReport}>
                                            RIMUOVI DA REPORT <Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                        <Button type="hollow" onClick={() => setNeedConfirm(true)}>
                                            MODIFICA DATI <SquarePen size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                    </div>
                                    <Button type="hollow" onClick={ripristinaModifiche} classes="w-[70%] mt-2">
                                        RIPRISTINA MODIFICHE <PenOff size={16} strokeWidth={2} className="inline-block ml-1" />
                                    </Button>
                                </>

                            )}
                        </PopUp>
                    </>
                ) : (
                    // Report chiusi
                    <>
                        <Table
                            headers={headersChiusi}
                            keyForPreview={["NomeAzienda", "DataIntervento", "DataChiusura"]}
                            data={dataTableChiusi}
                            setData={setDataTableChiusi}
                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCChiusi data={rowData} />}
                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                            itemsPC={8}
                            itemsMobile={5}
                            needResearch={true}
                            notFoundMessage="Nessun report chiuso"
                            clickableRow={true}
                            actionRow={(row, rowIndex) => { setInfoReport(row.value); setIsReportCVisible(true); setStepChiusi(false); loadManutenzioniByReport(row.value.ID); }}
                        />
                        <PopUp title={stepChiusi ? "Manutenzioni Eseguite" : ""}
                            isVisible={isReportCVisible}
                            setIsVisible={setIsReportCVisible}
                        >
                            {
                                stepChiusi ? (
                                    <div className="flex flex-col">
                                        <div className="flex items-center justify-between w-full mt-2">
                                            <div className="flex items-center hover:cursor-pointer text-blue-600" onClick={() => { setStepChiusi(false); }}>
                                                <MoveLeft size={16} strokeWidth={2} className="inline-block mr-1" /> TORNA INDIETRO
                                            </div>
                                        </div>
                                        <Table
                                            headers={headersManut}
                                            keyForPreview={['Data', 'EmailUtente', 'NomeComponente']}
                                            data={infoManut}
                                            setData={setInfoManut}
                                            renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPCAttesa data={rowData} />}
                                            renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                                            forceSmall={true}
                                            itemsPC={8}
                                            itemsMobile={3}
                                            needResearch={true}
                                            classes="mt-2"
                                        />
                                    </div>
                                ) : (
                                    <>
                                        <div className="grid grid-cols-2 mt-2 gap-2">
                                            <Button type="hollow" onClick={() => { setStepChiusi(true); }}>
                                                INFO MANUTENZIONI <Info size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                            <Button type="hollow" onClick={() => { previewReport(); }}>
                                                PREVIEW PDF <Eye size={16} strokeWidth={2} className="inline-block ml-1" />
                                            </Button>
                                        </div>
                                    </>
                                )}
                        </PopUp>
                    </>
                )}
                <PopUp title={"Anteprima Report"}
                    isVisible={isReportVisible}
                    setIsVisible={() => { setIsReportVisible(false); setContentReport(null); }}
                    needXL={true}
                >
                    <div className="w-full p-2 rounded-lg bg-white text-black">
                        <div
                            className="w-full h-full bg-white text-black overflow-y-auto"
                            dangerouslySetInnerHTML={{ __html: contentReport }}>
                        </div>
                    </div>
                </PopUp>
            </div>
        </div>
    )
};
export default Report;